<template>
  <div class="app-container">
    <el-tabs v-model="active" @tab-click="handleClick" type="card" class="cardTabs">
      <el-tab-pane label="阶段分化" name="0"></el-tab-pane>
      <el-tab-pane label="中考分化" name="1"></el-tab-pane>
      <el-tab-pane label="科任统计" name="2"></el-tab-pane>
    </el-tabs>
    <list ref="list" v-if="active==0">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport('list')" type="primary" plain>导出</el-button>
      </template>
    </list>
    <list2 ref="list2" v-if="active==1">
      <template slot="toolbar-right" v-if="!isMB">
        <el-button size="small" class="filter-item" @click="onExport('list2')" type="primary" plain>导出</el-button>
      </template>
    </list2>
    <list3 ref="list3" v-if="active==2">
      <template slot="toolbar-right" v-if="!isMB" @canExport="canExport">
        <el-button size="small" class="filter-item" @click="onExport('list3')" :disabled="listexport" type="primary" plain>导出</el-button>
      </template>
    </list3>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/analyse/warning/list";
import list2 from "@/components/analyse/warning/list2";
import list3 from "@/components/analyse/warning/list3";

export default {
  name: "warning",
  mixins: [curdMixins],
  components: {
    list,
    list2,
    list3,
  },
  data() {
    return {
      active: "0",
      last: -1,
      isMB: this.$store.state.isMB,
      listexport: false,
    }
  },
  methods: {
    reload() {
      this.handleClick(this.active);
    },
    onExport(name) {
      this.$refs[name].export();
    },
    handleClick(e) {
      if(this.active == this.last) {
        return
      } else {
        this.last = this.active;
      }
      setTimeout(() => {
        if(this.active=='0') {
          this.$refs.list.getData();
        } else if(this.active=='1') {
          this.$refs.list2.getData();
        } else if(this.active=='2') {
          this.$refs.list3.getData();
        }
      }, 200);
    },
    canExport(bool) {
      this.listexport = bool;
    }
  },
};
</script>